export class DiseaseTimeUnit {
    value: string;
    description: string;
}